import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import ImageData from './ImageData'
import ShareButton from './ShaireButtion'
import ProgressBar from './ProgressBar';


function UploadImage() {
    const [file, setFile] = useState();
    const [name, setName] = useState('');
    const [imgLink, setImgLink] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [copyLink, setCopyLink] = useState('Copy link');
    const [showh1, setShow1] = useState(false);

    const handleApi = (e) => {
        setFile(e.target.files[0]);
        setName(e.target.files[0].name.split(' ').join(''));
        setShow1(true)

    }

    useEffect(() => {
        const getIamge = async () => {
            if (file) {
                let data = new FormData();
                data.append('name', name);
                data.append('file', file);

                try {
                    const imglink = await axios.post('https://fileshairingapp.onrender.com/upload', data, {
                        onUploadProgress: (progressEvent) => {
                            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            setUploadProgress(progress);
                        }
                    });
                    setImgLink(imglink.data.data);
                } catch (error) {
                    console.log(error);
                }
            }
        }

        getIamge();
    }, [file, name]);

    const textRef = useRef(null);

    const handleCopyClick = () => {
        textRef.current.select();
        document.execCommand('copy');
        setCopyLink('Copied link');
    };

    return (
        <div>
            <>
                <label id='upload' htmlFor='file'>Upload file</label>
                <input id='file' onChange={(e) => handleApi(e)} style={{ display: "none" }} type='file'></input>
                <p className='link'><a>{imgLink}</a></p>

                <textarea
                    ref={textRef}
                    defaultValue={imgLink}
                    style={{ position: 'absolute', left: '-9999px' }}
                    readOnly
                />
                {imgLink !== '' &&
                    <>
                        <button className='bu' onClick={handleCopyClick}>{copyLink}</button>
                        <ShareButton url={imgLink} />
                    </>
                }

                <div className="centered-text">
                  {showh1 && uploadProgress === 0 && <h2 className='server'>Connecting...</h2>}
                </div>

                { uploadProgress > 0 && uploadProgress < 101 && imgLink === ''   &&
                    <div className='bar'>
                        <div className='dddd'>
                        <div className='progress-bar'>
                            <ProgressBar percentage={uploadProgress} />
                            <h2 className='lod'>Uploading: <span>{uploadProgress}%</span></h2>
                            
                            
                        </div>
                        </div>
                    </div>
                }

                {imgLink !== '' &&
                    <ImageData imgLink={imgLink} />
                }
            </>
        </div>
    );
}

export default UploadImage;
